module.exports = __webpack_public_path__ + "img/Business Mathematics.18593606.jpg";